import styled, { css, keyframes } from 'styled-components';
const ANIMATIONS = {
  clickTileItem: keyframes(["30%{transform:rotateZ(7deg)}60%{transform:rotateZ(-7deg)}100%{transform:rotateZ(0)}"]),
  clickSectionItem: keyframes(["50%{transform:rotateZ(-1deg)}100%{transform:rotateZ(0)}"]),
  clickLayoutItem: keyframes(["30%{transform:rotateZ(3deg)}60%{transform:rotateZ(-3deg)}100%{transform:rotateZ(0)}"])
};
export const WigglyAnimation = styled.div.withConfig({
  displayName: "WigglyAnimation",
  componentId: "anw8tk-0"
})(({
  $animationName,
  $isWiggly
}) => {
  return $isWiggly ? css(["animation-duration:350ms;animation-timing-function:ease;animation-name:", ";"], ANIMATIONS[$animationName]) : undefined;
});